<template lang="pug">
div
  h1 Clone Issue

  LoaderOverlay(:loading="loading")
    IssueForm(saveAction="clone")
</template>

<script>
  import { mapStores } from 'pinia'
  import { useIssueStore } from '@/stores/issue'
  import { usePagesStore } from '@/stores/pages'

  import IssueForm from '../shared/form.vue'
  import LoaderOverlay from '@/components/shared/loader_overlay.vue'

  export default {
    components: {
      IssueForm,
      LoaderOverlay
    },

    props: {
      issueId: {
        type: Number,
        required: true
      }
    },

    data() {
      return {
        loading: true
      }
    },

    computed: {
      ...mapStores(useIssueStore, usePagesStore)
    },

    async mounted() {
      const { issueId } = this

      await this.issueStore.$reset()
      await this.issueStore.fetchForCloning({ issueId })
      await this.pagesStore.$reset()
      await this.pagesStore.fetch({ issueId })
      this.loading = false
    }
  }
</script>
